module.exports = __webpack_public_path__ + "img/01uni-urushi.9bdcbd84.png";